export class EntityInitializationTracker {
    constructor() {
        this.statusMap = new Map();
    }
    getStatus(id) {
        return this.statusMap.get(id) || "uninitialized";
    }
    shouldInitialize(id) {
        const status = this.getStatus(id);
        return status === "uninitialized" || status === "failed";
    }
    markInitStarted(id) {
        this.statusMap.set(id, "in_flight");
    }
    markInitialized(id) {
        this.statusMap.set(id, "initialized");
    }
    markFailed(id) {
        this.statusMap.set(id, "failed");
    }
    reset(id) {
        if (id !== undefined) {
            this.statusMap.delete(id);
        }
        else {
            this.statusMap.clear();
        }
    }
    isInFlight(id) {
        return this.getStatus(id) === "in_flight";
    }
    isInitialized(id) {
        return this.getStatus(id) === "initialized";
    }
    hasFailed(id) {
        return this.getStatus(id) === "failed";
    }
}
